import { Text, Markdown } from '@devfolioco/genesis';
import React from 'react';
import styled from 'styled-components';

import CodeSnippet from 'components/CodeSnippet';
import * as S from '../style';

const StyledMarkdown = styled(Markdown)`
  p:first-child {
    margin-top: 16px;
  }
`;

const QuestionTitle = React.memo(({ number, total, text, codeSnippet, codeSnippetLanguage }) => (
  <>
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        userSelect: 'none',
        marginRight: 24,
        marginTop: 22,
      }}
    >
      <S.QuestionNumber>
        <Text upgrade size={48} weight="extrabold" style={{ marginRight: 6, lineHeight: '48px' }}>
          {number}
        </Text>
        <Text upgrade size={20} weight="bold">
          / {total}
        </Text>
      </S.QuestionNumber>

      <S.QuestionContainer>
        <Text upgrade size={20} weight="bold">
          <StyledMarkdown>{text}</StyledMarkdown>
        </Text>

        {codeSnippet && <CodeSnippet code={codeSnippet} language={codeSnippetLanguage} />}
      </S.QuestionContainer>
    </div>
  </>
));

export default QuestionTitle;
